export enum ValidationPropertyType {
	NOT_NULL = 'NotNull',
	NOT_EMPTY = 'NotEmpty',
	EMAIL = 'Email',
	NUMBER = 'Number',
	INTEGER = 'Integer',
	LESS_THAN = 'LessThan',
	LESS_THAN_OR_EQUAL = 'LessThanOrEqual',
	GREATER_THAN = 'GreaterThan',
	GREATER_THAN_OR_EQUAL = 'GreaterThanOrEqual',
	LENGTH = 'Length',
	EXACT_LENGTH = 'ExactLength',
	MINIMUM_LENGTH = 'MinimumLength',
	MAXIMUM_LENGTH = 'MaximumLength',
	REGULAR_EXPRESSION = 'RegularExpression',
	LIBELLE_MAJUSCULES = 'LibelleMajuscules',
	LIBELLE_CONTRAINT = 'LibelleContraint',
	NOT_EQUAL = 'NotEqual',
	NOT_MULTIPLE_MONTHLY_SUM = 'notMultipleMonthlySum',

	AT_LEAST_DIGIT_CHAR = 'AtLeastXDigit',
	AT_LEAST_LOWERCASE_CHAR = 'AtLeastXLowerCaseChar',
	AT_LEAST_UPPERCASE_CHAR = 'AtLeastXUpperCaseChar',
	AT_LEAST_SPECIAL_CHAR = 'AtLeastXSpecialChar',
	BEFORE_NOW = 'BeforeNow',
	AFTER_NOW = 'AfterNow',
	BEFORE_TODAY = 'BeforeToday',
	AFTER_TODAY = 'AfterToday',
	OLDER_THAN_DAYS = 'OlderThanXDays',
	NOT_OLDER_THAN_DAYS = 'NotOlderThanXDays',
	YOUNGER_THAN_DAYS = 'YoungerThanXDays',
	VALID_ID = 'ValidId',

	ENUM = 'Enum',
	CHILD_VALIDATOR_ADAPTOR = 'ChildValidatorAdaptor',
	PREDICATE = 'Predicate',
	ASYNC_PREDICATE = 'AsyncPredicate',
	BETWEEN_NUMBER = 'betweenNumber',
	IBAN_LENGTH = 'ibanLength',
	IBAN_FORMAT_ISO = 'ibanFormatISO',
	IBAN_WRONG_KEY = 'wrongIbanKey',
	WRONG_SWIFT_BIC_LEN = 'wrongSwiftBicLength',
	WRONG_SIREN_LEN = 'wrongSirenLength',
	WRONG_SIRET_LEN = 'wrongSiretLength',
	WRONG_Rcs_Format = 'wrongRcsFormat',
	WRONG_REGEQUI_LEN = 'wrongRegistreEquivalentLength',
	SWIFT_FORMAT_ISO = 'swiftFormatISO',
	WRONG_TVA_Format = 'wrongTVAFormat',
	WRONG_TELEPHONE_LEN = 'wrongTelephoneLength'
}
